import { Link } from 'react-router-dom';
import { contactInfo, services } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-accent-800 text-background-50/90">
      <div className="max-w-7xl mx-auto px-4 md:px-6 pt-16 pb-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-6">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-5">
              <span className="font-heading text-xl font-bold text-white">Dra. Marihana</span>
            </Link>
            <p className="text-background-50/60 text-sm leading-relaxed mb-5">
              Transformando sorrisos com excelência, tecnologia e cuidado humano.
              Consultório premium na região da Faria Lima, São Paulo.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={`https://instagram.com/${contactInfo.instagram.replace('@', '')}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-background-50/10 rounded-full text-background-50/70 hover:bg-background-50/20 hover:text-white transition-all cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line"></i>
              </a>
              <a
                href={`https://wa.me/${contactInfo.whatsapp}`}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center bg-background-50/10 rounded-full text-background-50/70 hover:bg-[#25D366] hover:text-white transition-all cursor-pointer"
                aria-label="WhatsApp"
              >
                <i className="ri-whatsapp-line"></i>
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="w-9 h-9 flex items-center justify-center bg-background-50/10 rounded-full text-background-50/70 hover:bg-background-50/20 hover:text-white transition-all cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/50 font-semibold mb-5">Serviços</h4>
            <ul className="space-y-2.5">
              {services.map((service) => (
                <li key={service.id}>
                  <Link
                    to={service.slug}
                    className="text-sm text-background-50/70 hover:text-white transition-colors"
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/50 font-semibold mb-5">Links Úteis</h4>
            <ul className="space-y-2.5">
              {[
                { label: 'Diferenciais', href: '/#diferenciais' },
                { label: 'Jornada do Paciente', href: '/#jornada' },
                { label: 'Depoimentos', href: '/#depoimentos' },
                { label: 'Galeria', href: '/#galeria' },
                { label: 'Dúvidas Frequentes', href: '/#faq' },
                { label: 'Localização', href: '/#localizacao' },
              ].map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-sm text-background-50/70 hover:text-white transition-colors">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-widest text-background-50/50 font-semibold mb-5">Contato</h4>
            <ul className="space-y-3 text-sm text-background-50/70">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-background-50/50"></i>
                <span>{contactInfo.address}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-background-50/50"></i>
                <a href={`tel:${contactInfo.phone}`} className="hover:text-white transition-colors">
                  {contactInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-background-50/50"></i>
                <a href={`mailto:${contactInfo.email}`} className="hover:text-white transition-colors">
                  {contactInfo.email}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-background-50/50"></i>
                <span>Seg-Sex: 8h às 19h | Sáb: 8h às 13h</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} Dra. Marihana Pasquali. Todos os direitos reservados. CRO-SP 172094.
          </p>
          <div className="flex items-center gap-6">
            <p className="text-xs text-background-50/40">
              Responsável Técnico: Dra. Marihana Pasquali
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}